import { Stack } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

import { LoadingButton } from "../redesign/components/LoadingButton";

interface CancelRateNegotiationDialogFooterProps {
  handleEndNegotiation: () => void;
  isEndingNegotiation: boolean;
}

export function CancelRateNegotiationDialogFooter(props: CancelRateNegotiationDialogFooterProps) {
  const { handleEndNegotiation, isEndingNegotiation } = props;

  return (
    <DialogFooter withShadow orientation="vertical" sx={{ marginBottom: 4 }}>
      <Stack direction="column" alignItems="center" gap={5} sx={{ width: "100%" }}>
        <LoadingButton
          fullWidth
          size="large"
          variant="outlined"
          isLoading={isEndingNegotiation}
          onClick={handleEndNegotiation}
        >
          Yes, end negotiation
        </LoadingButton>
      </Stack>
    </DialogFooter>
  );
}
